import React, { useState, useEffect } from 'react';

function FittingSchedule() {
  const [schedule, setSchedule] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    customer_id: '', product_id: '', fitting_type: 'first_viewing', scheduled_at: '', location: '', notes: ''
  });

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const [scheduleRes, customersRes, productsRes] = await Promise.all([
        fetch('/api/fitting-schedule', { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch('/api/customers?limit=1000', { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch('/api/products?limit=1000', { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      const scheduleData = await scheduleRes.json();
      const customersData = await customersRes.json();
      const productsData = await productsRes.json();
      setSchedule(scheduleData.schedule || []);
      setCustomers(customersData.data || []);
      setProducts(productsData.data || productsData || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('crm_token');
      const res = await fetch('/api/fitting-schedule', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (res.ok) { setShowModal(false); fetchData(); setFormData({ customer_id: '', product_id: '', fitting_type: 'first_viewing', scheduled_at: '', location: '', notes: '' }); }
      else { alert(data.error || 'Kaydetme hatası'); }
    } catch (error) { console.error('Error:', error); }
  };

  const getFittingTypeLabel = (type) => {
    const labels = {
      first_viewing: 'İlk Görüntüleme',
      measurement: 'Ölçü Alma',
      first_fitting: '1. Prova',
      second_fitting: '2. Prova',
      third_fitting: '3. Prova',
      final_fitting: 'Son Prova',
      delivery: 'Teslimat'
    };
    return labels[type] || type;
  };

  const getCustomerName = (id) => { const c = customers.find(c => c.id == id); return c ? `${c.first_name} ${c.last_name}` : '-'; };
  const getProductName = (id) => { const p = products.find(p => p.id == id); return p ? p.name : '-'; };
  const formatDateTime = (dt) => {
    if (!dt) return '-';
    const d = new Date(dt);
    return d.toLocaleDateString('tr-TR') + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h1>Prova Takvimi</h1>
        <button className="btn-primary" onClick={() => setShowModal(true)}>+ Yeni Prova Ekle</button>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Tarih/Saat</th>
              <th>Müşteri</th>
              <th>Ürün</th>
              <th>Prova Türü</th>
              <th>Konum</th>
              <th>Notlar</th>
            </tr>
          </thead>
          <tbody>
            {schedule.length === 0 ? (
              <tr><td colSpan="6" style={{textAlign:'center'}}>Henüz prova yok</td></tr>
            ) : schedule.map(s => (
              <tr key={s.id}>
                <td>{formatDateTime(s.scheduled_at)}</td>
                <td>{getCustomerName(s.customer_id)}</td>
                <td>{getProductName(s.product_id)}</td>
                <td>{getFittingTypeLabel(s.fitting_type)}</td>
                <td>{s.location}</td>
                <td>{s.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Yeni Prova</h2>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Müşteri</label>
                <select value={formData.customer_id} onChange={e => setFormData({...formData, customer_id: e.target.value})} required>
                  <option value="">Seçiniz</option>
                  {customers.map(c => <option key={c.id} value={c.id}>{c.first_name} {c.last_name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Ürün</label>
                <select value={formData.product_id} onChange={e => setFormData({...formData, product_id: e.target.value})} required>
                  <option value="">Seçiniz</option>
                  {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Prova Türü</label>
                <select value={formData.fitting_type} onChange={e => setFormData({...formData, fitting_type: e.target.value})}>
                  <option value="first_viewing">İlk Görüntüleme</option>
                  <option value="measurement">Ölçü Alma</option>
                  <option value="first_fitting">1. Prova</option>
                  <option value="second_fitting">2. Prova</option>
                  <option value="third_fitting">3. Prova</option>
                  <option value="final_fitting">Son Prova</option>
                  <option value="delivery">Teslimat</option>
                </select>
              </div>
              <div className="form-group">
                <label>Tarih/Saat</label>
                <input type="datetime-local" value={formData.scheduled_at} onChange={e => setFormData({...formData, scheduled_at: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Konum</label>
                <input type="text" value={formData.location} onChange={e => setFormData({...formData, location: e.target.value})} />
              </div>
              <div className="form-group">
                <label>Notlar</label>
                <textarea value={formData.notes} onChange={e => setFormData({...formData, notes: e.target.value})} />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                <button type="submit" className="btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`
        .page { padding: 24px; }
        .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; }
        .page-header h1 { font-size: 24px; font-weight: 700; color: #FFFFFF; margin: 0; }
        .table-container { background: rgba(17,17,24,0.7); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; overflow: hidden; backdrop-filter: blur(12px); }
        .table { width: 100%; border-collapse: collapse; }
        .table th, .table td { padding: 14px 16px; text-align: left; border-bottom: 1px solid rgba(255,255,255,0.05); color: #E5E7EB; }
        .table th { background: rgba(26,26,36,0.6); font-weight: 600; color: #9CA3AF; font-size: 13px; }
        .table tr:hover { background: rgba(59,130,246,0.05); }
        .btn-primary { background: linear-gradient(135deg, #3B82F6, #2563EB); color: white; border: none; padding: 10px 20px; border-radius: 10px; cursor: pointer; font-weight: 600; box-shadow: 0 4px 12px rgba(59,130,246,0.3); transition: all 0.2s; }
        .btn-primary:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(59,130,246,0.4); }
        .btn-secondary { background: rgba(255,255,255,0.06); color: #E5E7EB; border: 1px solid rgba(255,255,255,0.1); padding: 10px 20px; border-radius: 10px; cursor: pointer; font-weight: 500; }
        .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.75); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 1000; }
        .modal { background: rgba(17,17,24,0.95); border: 1px solid rgba(255,255,255,0.1); padding: 24px; border-radius: 20px; width: 500px; max-height: 90vh; overflow-y: auto; box-shadow: 0 24px 48px rgba(0,0,0,0.6); backdrop-filter: blur(40px); }
        .modal h2 { margin: 0 0 20px; font-size: 20px; color: #FFFFFF; }
        .form-group { margin-bottom: 16px; }
        .form-group label { display: block; margin-bottom: 6px; font-weight: 500; color: #E5E7EB; }
        .form-group input, .form-group select, .form-group textarea { width: 100%; padding: 10px 12px; border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; font-size: 14px; background: rgba(26,26,36,0.8); color: #FFFFFF; }
        .form-group select option { background: #111118; }
        .form-group textarea { min-height: 80px; }
        .modal-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; }
        .loading { display: flex; align-items: center; justify-content: center; height: 100vh; color: #60A5FA; font-size: 18px; }
      `}</style>
    </div>
  );
}

export default FittingSchedule;
